<template>
  <dtunes-modal @openModal="dialog = true" @closeModal="dialog = false">
    <template v-slot:button>
      <v-icon>mdi-plus</v-icon>
      Create New Range
    </template>
    <template v-slot:content>
      <v-card class="pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center">Create New Range</p>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-select color="auto" v-model="selectedCoin" :items="coins" label="select a coin" outlined
              item-text="coinName"></v-select>
            <v-row>
              <v-col>
                <label for="">transaction Range (From)</label>
                <v-text-field color="auto" v-model="lowerRange" type="number" outlined></v-text-field>
              </v-col>
              <v-col>
                <label for="">transaction Range (To)</label>
                <v-text-field color="auto" v-model="upperRange" type="number" outlined></v-text-field>
              </v-col>
            </v-row>
            <label for="">Confirmation Charge</label>
            <v-text-field color="auto" v-model="nairaValue" type="number" outlined></v-text-field>


            <default-button @click="createCoinRate" :loading="loading">Create
              Range</default-button>
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>
// ============= IMPORT COMPONENT ===========
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from "@/components/Buttons/default-button.vue";

// =========== IMPORT SERVICES =============
import { PermissionService, CryptoService } from "@/services";
import app from '@/main'

export default {
  components: {
    DtunesModal,
    DefaultButton,
  },
  data: () => ({
    email: "",
    nairaValue: 0,
    selectedCoin: '',
    lowerRange: 0,
    upperRange: 0,
    // Permissions: [],
    loading: false,
  }),
  props: {
    coins: Array
  },
  mounted() {
    // this.getPermissions();
  },
  methods: {


    async createCoinRate() {
      let rate = {
        confirmation_charge: Number(this.nairaValue) ,
        min: Number(this.lowerRange),
        max: Number(this.upperRange)
      };
      let coin = {};
      this.coins.forEach((c) => {
        if (c.coinName == this.selectedCoin) return coin = c;
      })
      this.loading = true;
      let data = await CryptoService.createCoinRate(rate, coin.id);
      if (data) {
        this.loading = false;
        this.dialog = false;
        app.$store.dispatch('toast', {
          message: 'coin rate created',
          variant: 'success'
        })
      //  this.$forceUpdate();
        this.coins.forEach((c, i)=>{
          if(coin.id == c.id) return this.coins[i].rates.push(data);
        })
        
       this.$emit('refresh');
        //alert('success');
      }

    },
    async getPermissions() {
      const data = await PermissionService.getPermissions();
      this.Permissions = data;
    },
  },
};
</script>